import BaseTable, {AutoResizer, SortOrder} from 'react-base-table'
import React, {useEffect, useState} from 'react';
import 'react-base-table/styles.css'
import './base-table.css'
import styled from 'styled-components';

const CharTable = ({charData}) => {
    const [data, setData] = useState({});
    const [sortBy, setSortBy] = useState({
        key: 'nsn', 
        order: SortOrder.ASC
    })

    useEffect(() => {
    
        setData(charData.map((doc, index) => {
            return {
                requirements_statement: doc.requirements_statement,
                clear_text_reply: doc.clear_text_reply
            }
        }));
    }, [charData])

    const columns = [
        {
            key: 'requirements_statement',
            dataKey: 'requirements_statement',
            title: 'Characteristic',
            width: 150,
            align: 'center',
            resizable: true,
            sortable: false
        },

        {
        key: 'clear_text_reply',
        dataKey: 'clear_text_reply',
        title: 'Description',
        width: 150,
        align: 'center',
        resizable: true,
        sortable: false
        }

    ]

    const Container = styled.div`
        width: calc(50vw + 220px);
        height: 50vh;
        `


return (
    <>
        <Container>
            <AutoResizer>
                {({ width, height }) => (
                    <BaseTable
                        className='base-table'
                        width={width}
                        height={height}
                        columns={columns}
                        data={data}
                        sortBy={sortBy}
                        
                    />
                )}
            </AutoResizer>
        </Container>
    </>
    );
}

export default CharTable